const style = {
  wrapper: {
    background: `#f6f6f6`
  },
  list: {
    listStyle: `none`,
    height: `100%`,
    margin: 0,
    padding: 0
  },
  item: {
    position: `relative`,
    color: `#666`,
    margin: 0,
    textAlign: `center`
  },
  itemLink: {
    color: `#666`,
    padding: `20px 30px`,
    textDecoration: `none`,
    fontSize: `15px`,
    fontWeight: `300`,
    borderBottom: `1px solid transparent`,
    ':hover': {
      color: `#A94545`,
      '@media only screen and (min-width : 1200px)': {
        borderColor: `#A94545`
      }
    }
  },
  activeLink: {
    color: `#A94545`,
    '@media only screen and (min-width : 1200px)': {
      borderColor: `#A94545`
    }
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/DashboardNavigation/style/list.js